import React, { useState, useEffect } from 'react';
import { getSDRs, updateStatusDia } from '../services/api';

function CheckinSDR({ embedded = false }) {
    const [sdrs, setSdrs] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [savingNome, setSavingNome] = useState(null);
    const [statusMessage, setStatusMessage] = useState({ type: '', text: '' });

    const carregarSDRs = async () => {
        setIsLoading(true);
        setStatusMessage({ type: '', text: '' });
        try {
            const data = await getSDRs();
            setSdrs(data);
        } catch {
            setStatusMessage({ type: 'error', text: 'Erro ao carregar SDRs. Atualize a página.' });
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => { carregarSDRs(); }, []);

    const handleToggle = async (nome, checked) => {
        const anterior = sdrs;
        setSdrs(prev => prev.map(s => s.nome === nome ? { ...s, status_dia: checked ? 1 : 0 } : s));
        setSavingNome(nome);
        setStatusMessage({ type: '', text: '' });
        try {
            await updateStatusDia(nome, checked);
        } catch {
            setSdrs(anterior);
            setStatusMessage({ type: 'error', text: `Erro ao atualizar status de ${nome}.` });
        } finally {
            setSavingNome(null);
        }
    };

    const ativos = sdrs.filter(s => s.status_dia === 1).length;

    return (
        <>
            {!embedded && (
                <div className="page-header">
                    <div className="page-header-left">
                        <div>
                            <div className="page-kicker">Operações</div>
                            <h1 className="page-title">Check-in SDR</h1>
                        </div>
                    </div>
                    {!isLoading && sdrs.length > 0 && (
                        <div className="page-header-right">
                            <span className="chip chip-active">{ativos}/{sdrs.length} ativos</span>
                        </div>
                    )}
                </div>
            )}

            <div className="page-body" style={embedded ? { minHeight: 'auto' } : undefined}>
                {statusMessage.text && (
                    <div className={`alert alert-${statusMessage.type === 'error' ? 'error' : 'success'}`}>
                        {statusMessage.text}
                    </div>
                )}

                {isLoading ? (
                    <div className="loading-state">Carregando SDRs...</div>
                ) : sdrs.length === 0 ? (
                    <div className="empty-state">Nenhum SDR cadastrado.</div>
                ) : (
                    <div className="card">
                        <p className="section-label">Status do dia</p>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '0' }}>
                            {sdrs.map((sdr, i) => {
                                const ativo = sdr.status_dia === 1;
                                const saving = savingNome === sdr.nome;
                                return (
                                    <label
                                        key={sdr.nome}
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                            padding: '0.875rem 0',
                                            borderBottom: i < sdrs.length - 1 ? '1px solid var(--glass-border)' : 'none',
                                            cursor: saving ? 'wait' : 'pointer',
                                            opacity: saving ? 0.6 : 1,
                                        }}
                                    >
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.875rem' }}>
                                            <div style={{
                                                width: '8px', height: '8px', borderRadius: '50%',
                                                background: ativo ? 'var(--emerald)' : 'rgba(240,245,242,0.2)',
                                                boxShadow: ativo ? '0 0 6px var(--emerald)' : 'none',
                                                flexShrink: 0,
                                            }} />
                                            <span style={{ color: 'var(--ink)', fontWeight: 500, fontSize: '0.9375rem' }}>{sdr.nome}</span>
                                        </div>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.875rem' }}>
                                            <span className={ativo ? 'chip chip-active' : 'chip chip-danger'} style={{ fontSize: '0.7rem' }}>
                                                {ativo ? 'Ativo' : 'Inativo'}
                                            </span>
                                            <input
                                                type="checkbox"
                                                checked={ativo}
                                                disabled={saving}
                                                onChange={(e) => handleToggle(sdr.nome, e.target.checked)}
                                                style={{ width: '20px', height: '20px', cursor: saving ? 'wait' : 'pointer', accentColor: 'var(--emerald)', flexShrink: 0 }}
                                            />
                                        </div>
                                    </label>
                                );
                            })}
                        </div>
                    </div>
                )}
            </div>
        </>
    );
}

export default CheckinSDR;
